export const GET_MONITOREOS_INTERNET_LOADING = 'monitoreosInternet/GET_MONITOREOS_INTERNET_LOADING';
export const GET_MONITOREOS_INTERNET_SUCCESS = 'monitoreosInternet/GET_MONITOREOS_INTERNET_SUCCESS';
export const GET_MONITOREOS_INTERNET_FAILURE = 'monitoreosInternet/GET_MONITOREOS_INTERNET_FAILURE';

export const UPSERT_MONITOREOS_INTERNET_LOADING =
  'monitoreosInternet/UPSERT_MONITOREOS_INTERNET_LOADING';
export const UPSERT_MONITOREOS_INTERNET_SUCCESS =
  'monitoreosInternet/UPSERT_MONITOREOS_INTERNET_SUCCESS';
export const UPSERT_MONITOREOS_INTERNET_FAILURE =
  'monitoreosInternet/UPSERT_MONITOREOS_INTERNET_FAILURE';

export const GET_MONITOREOS_EVENTOS_LOADING = 'monitoreosEventos/GET_MONITOREOS_EVENTOS_LOADING';
export const GET_MONITOREOS_EVENTOS_SUCCESS = 'monitoreosEventos/GET_MONITOREOS_EVENTOS_SUCCESS';
export const GET_MONITOREOS_EVENTOS_FAILURE = 'monitoreosEventos/GET_MONITOREOS_EVENTOS_FAILURE';

export const UPSERT_MONITOREOS_EVENTOS_LOADING =
  'monitoreosInternet/UPSERT_MONITOREOS_EVENTOS_LOADING';
export const UPSERT_MONITOREOS_EVENTOS_SUCCESS =
  'monitoreosInternet/UPSERT_MONITOREOS_EVENTOS_SUCCESS';
export const UPSERT_MONITOREOS_EVENTOS_FAILURE =
  'monitoreosInternet/UPSERT_MONITOREOS_EVENTOS_FAILURE';

export const GET_MONITOREOS_CASAS_LOADING = 'monitoreosEventos/GET_MONITOREOS_CASAS_LOADING';
export const GET_MONITOREOS_CASAS_SUCCESS = 'monitoreosEventos/GET_MONITOREOS_CASAS_SUCCESS';
export const GET_MONITOREOS_CASAS_FAILURE = 'monitoreosEventos/GET_MONITOREOS_CASAS_FAILURE';

export const UPSERT_MONITOREOS_CASAS_LOADING = 'monitoreosInternet/UPSERT_MONITOREOS_CASAS_LOADING';
export const UPSERT_MONITOREOS_CASAS_SUCCESS = 'monitoreosInternet/UPSERT_MONITOREOS_CASAS_SUCCESS';
export const UPSERT_MONITOREOS_CASAS_FAILURE = 'monitoreosInternet/UPSERT_MONITOREOS_CASAS_FAILURE';

export const GET_MONITOREOS_MEDIOS_IMP_LOADING =
  'monitoreosInternet/GET_MONITOREOS_MEDIOS_IMP_LOADING';
export const GET_MONITOREOS_MEDIOS_IMP_SUCCESS =
  'monitoreosInternet/GET_MONITOREOS_MEDIOS_IMP_SUCCESS';
export const GET_MONITOREOS_MEDIOS_IMP_FAILURE =
  'monitoreosInternet/GET_MONITOREOS_MEDIOS_IMP_FAILURE';

export const UPSERT_MONITOREOS_MEDIOS_IMP_LOADING =
  'monitoreosInternet/UPSERT_MONITOREOS_MEDIOS_IMP_LOADING';
export const UPSERT_MONITOREOS_MEDIOS_IMP_SUCCESS =
  'monitoreosInternet/UPSERT_MONITOREOS_MEDIOS_IMP_SUCCESS';
export const UPSERT_MONITOREOS_MEDIOS_IMP_FAILURE =
  'monitoreosInternet/UPSERT_MONITOREOS_MEDIOS_IMP_FAILURE';
